<div
    class="agpr-mfaLogin-container"
    [agprLoading]="loading"
>
    <div
        class="agpr-mfaLogin-header-container"
    >
        <div class="agpr-mfaLogin-header-logo-container" *ngIf="logoUrl">
            <div class="agpr-mfaLogin-header-logoContainer" *ngIf="!logoRouterLink">
                <img
                    class="agpr-mfaLogin-header-logo"
                    [src]="logoUrl"
                    [alt]="logoAltText | localize"
                />
            </div>
            <a class="agpr-mfaLogin-header-logoContainer" *ngIf="logoRouterLink" [href]="logoRouterLink">
                <img
                    class="agpr-mfaLogin-header-logo"
                    [src]="logoUrl"
                    [alt]="logoAltText | localize"
                />
            </a>
        </div>
        <agpr-growler></agpr-growler>
    </div>

    <div class="agpr-mfaLogin-body-container">
        <div class="agpr-mfaLogin-body-content">
            <agpr-mfa-setup
                *ngIf="setupRequired"
                class="agpr-mfaLogin-setup"
                cancelLabel="Mfa.backToLogin"
                [confirm]="login.bind(this)"
                (cancel)="backToLogin()"
            ></agpr-mfa-setup>
            <div *ngIf="!setupRequired && selectedMfaMethod" class="agpr-mfaLogin-confirm">
                <h1 class="agpr-headerH1-darkSmaller">  {{ 'Mfa.login.confirm.heading'| localize }}  </h1>
                <ng-container *ngIf="!useDifferentMethod">
                    <agpr-message [severity]="messageSeverityEnum.info">
                        {{ 'Mfa.confirm.message.' + selectedMfaMethod.type | localize: {name: selectedMfaMethod.type === mfaTypes.email ? selectedMfaMethod.email : selectedMfaMethod.name} }}
                    </agpr-message>
                    <agpr-text-input
                        [id]="'mfaLogin_confirmationCode'"
                        label="Mfa.confirm.code"
                        [required]="true"
                        [maxLength]="6"
                        [(ngModel)]="selectedMfaMethod.confirmationCode"
                        ariaDescribedBy="mfaLogin_confirmationCode_error"
                    ></agpr-text-input>
                    <agpr-form-message id="mfaLogin_confirmationCode_error" *ngIf="isCodeInvalid">
                        {{  'Mfa.confirm.error.invalidCode' | localize }}
                    </agpr-form-message>
                </ng-container>
                <ng-container *ngIf="useDifferentMethod">
                    <ul
                        role="radiogroup"
                        [attr.aria-label]="'Mfa.login.confirm.methods'"
                    >
                        <label class="agpr-mfaLogin-label"> {{ 'Mfa.login.confirm.methods'| localize }} </label>

                        <li *ngFor="let method of verifiedMfaMethods; index as i">
                            <agpr-radio
                                [id]="'mfaLogin_mfMethod_' + i"
                                [label]="'Mfa.method.' + method.type | localize: {name: method.type === mfaTypes.email ? method.email : method.name}"
                                [value]="method"
                                [(ngModel)]="selectedMfaMethod"
                            ></agpr-radio>
                        </li>
                    </ul>
                </ng-container>

                <agpr-button
                    *ngIf="!useDifferentMethod && verifiedMfaMethods.length > 1"
                    class="agpr-mfaLogin-differentMethodButton"
                    label="Mfa.login.useDifferentMethod"
                    (click)="useDifferentMethod = true"
                    [style]="buttonTypes.link"
                ></agpr-button>

                <div class="agpr-mfaLogin-footerButton">
                    <div class="agpr-mfaLogin-footerButton--left">
                        <agpr-button
                            id="mfaLogin_cancel"
                            label="Mfa.backToLogin"
                            [style]="buttonTypes.secondary"
                            (click)="backToLogin()"
                        ></agpr-button>
                    </div>
                    <div class="agpr-mfaLogin-footerButton--right">
                        <agpr-button
                            *ngIf="useDifferentMethod"
                            id="mfaLogin_nextStep"
                            label="Mfa.nextStep"
                            [style]="buttonTypes.primary"
                            (click)="goToConfirm()"
                        ></agpr-button>
                        <agpr-button
                            *ngIf="!useDifferentMethod && selectedMfaMethod.type === mfaTypes.email"
                            id="mfaLogin_resendCode"
                            label="Mfa.resendCode"
                            [style]="buttonTypes.secondary"
                            (click)="goToConfirm()"
                        ></agpr-button>
                        <agpr-button
                            *ngIf="!useDifferentMethod"
                            id="mfaLogin_confirm"
                            label="Mfa.confirm"
                            [style]="buttonTypes.primary"
                            [disabled]="!selectedMfaMethod.confirmationCode"
                            (click)="performLogin()"
                        ></agpr-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="agpr-mfaLogin-copyright-container">
        <div *ngIf="!isResellerDomain" [innerHTML]="'Agility.copyright' | localize"></div>
        <div *ngIf="isResellerDomain">{{'Core.login.reseller.copyright' | localize}}</div>
    </div>
</div>

